import { LocalizedTypography, WithBreakpointRange, isMobile } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { Stack, Typography, withBreakpointRange } from '@optimus-web/core';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedText } from '@mews/framework';
import { normalizeChartData } from './utils';
import { HEIGHT_COEFFICIENT, REPAYMENT_COEFFICIENT } from './constants';
import { RepaymentBarItem } from './RepaymentBarItem';
import { ChartLegendMarker } from './styles';

interface RepaymentBarChartProps extends WithBreakpointRange {
    data: number[];
}

const RepaymentBarChartComponent: React.FC<RepaymentBarChartProps> = ({ data, breakpointRange }) => {
    const normalizedData = normalizeChartData({
        data,
        upperPartCoeff: REPAYMENT_COEFFICIENT,
        heightCoeff: HEIGHT_COEFFICIENT,
        isMobile: isMobile(breakpointRange),
    });

    return (
        <Stack vertical itemAlignment="center" spacing="400">
            <Stack spacing={isMobile(breakpointRange) ? '50' : '200'}>
                {normalizedData.map((item) => (
                    <RepaymentBarItem {...item} key={item.id} />
                ))}
            </Stack>
            <Stack vertical spacing="100" itemAlignment="center">
                <Stack spacing="100">
                    <ChartLegendMarker />
                    <LocalizedTypography
                        textKey={TextKey.FinancialServicesCapitalAutomaticRepaymentsExample}
                        textStyle="bodyMediumStrong"
                        as="div"
                    />
                </Stack>
                <Stack itemAlignment="center">
                    <Typography textStyle="bodyExtraSmall" variant="secondary" as="div">
                        {UnicodeEntity.Asterisk}
                        <LocalizedText textKey={TextKey.FinancialServicesCapitalTheFiguresShownAreIllustrative} />
                    </Typography>
                </Stack>
            </Stack>
        </Stack>
    );
};

export const RepaymentBarChart = withBreakpointRange(RepaymentBarChartComponent);
